export const RouteGuard = (path) => {
	const opts = <string[]>JSON.parse(localStorage.getItem('_O:Wequi') ?? '[]');
	
	return opts.includes(path);
}
